export const SET_PROTOCOL = 'SET_PROTOCOL';
export const SET_PROTOCOLS = 'SET_PROTOCOLS';
export const SET_PROTOCOL_ACTION = 'SET_PROTOCOL_ACTION';
export const SET_PROTOCOL_STUDY_EVENT_DEFINITION = 'SET_PROTOCOL_STUDY_EVENT_DEFINITION';
export const SET_PROTOCOL_STUDY_EVENT_PROCEDURE = 'SET_PROTOCOL_STUDY_EVENT_PROCEDURE';
export const SET_PROTOCOL_POSITIONS = 'SET_PROTOCOL_POSITIONS';
export const SET_PROTOCOL_STUDY_PROCEDURE_DEFINITION = 'SET_PROTOCOL_STUDY_PROCEDURE_DEFINITION';
export const SET_STUDY_EVENT_DEFINITION_FILTERED_BY_STUDY_ARM = 'SET_STUDY_EVENT_DEFINITION_FILTERED_BY_STUDY_ARM';
export const SET_STUDY_PROTOCOL_SITES_ASSIGNMENT_DATA = 'SET_STUDY_PROTOCOL_SITES_ASSIGNMENT_DATA';
export const SET_PROTOCOL_UPDATED = 'SET_PROTOCOL_UPDATED';
